// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"7d66f1ac","604":"29364c9b","787":"eea0390d"}[chunkId] + ".chunk.js";
};